<div class="auth-page">
  <div class="auth-card">
    <ng-container *ngIf="hasEmail">
      <h1 class="auth-heading">Confirm Email</h1>
      <p class="auth-subtitle">You need to confirm your email address before you can log in.</p>
      <p class="text-sm text-gray-600 text-center mb-6">
        Click the button to send a message to the email address associated with your account.
        When you receive the email message, click the link in the message to confirm your email address.
      </p>
    </ng-container>

    <ng-container *ngIf="!hasEmail">
      <h1 class="auth-heading">Add Email</h1>
      <p class="auth-subtitle">You need to provide your email address before you can log in.</p>
      <p class="text-sm text-gray-600 text-center mb-6">
        Enter your email address below, and click the button to send a confirmation message to it.
        When you receive the email message, click the link in the message to confirm your email address.
      </p>
    </ng-container>

    <form name="sendConfirmForm" #form="ngForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <input *ngIf="!hasEmail" pInputText id="email" placeholder="Email" type="email" [(ngModel)]="email" required
          name="email" class="w-full" />

        <div class="flex gap-2">
          <button pButton pRipple label="Cancel" type="button" class="flex-auto p-button-outlined"
            (click)="logout()"></button>
          <button pButton pRipple label="Send Email" type="submit" class="flex-auto" [disabled]="working"
            [loading]="working"></button>
        </div>

        <p class="text-red-500 text-center mt-3 mb-0" *ngIf="error">{{error}}</p>
        <p class="text-green-500 text-center mt-3 mb-0" *ngIf="success">
          A message has been sent to your email address.
          Click on the link in the message to confirm your email address.
        </p>
      </div>
    </form>

    <div class="auth-divider mt-6 mb-4">or</div>

    <p class="text-center text-sm text-gray-600 mb-0">
      A problem? <a routerLink="/auth/contact-us" class="text-primary font-medium hover:underline">Click here</a> and let
      us help you.
    </p>
  </div>
</div>
